/**
 * Utility function to generate asset URLs using the configured base URL
 * @param assetPath - The path to the asset (e.g., 'fsl-logo.svg', 'images/icon.png')
 * @returns Full URL to the asset
 */
export const getAssetUrl = (assetPath: string): string => {
  const baseUrl = import.meta.env.VITE_BASE_URL ?? '/';

  // Remove leading slash from assetPath if present to avoid double slashes
  const cleanAssetPath = assetPath.startsWith('/') ? assetPath.slice(1) : assetPath;

  // Ensure baseUrl ends with slash
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

  return `${cleanBaseUrl}${cleanAssetPath}`;
};
